import { render, staticRenderFns } from "./CartaoDeCondicoesDePagamento.vue?vue&type=template&id=18d9ddec&scoped=true"
import script from "./CartaoDeCondicoesDePagamento.vue?vue&type=script&setup=true&lang=js"
export * from "./CartaoDeCondicoesDePagamento.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CartaoDeCondicoesDePagamento.vue?vue&type=style&index=0&id=18d9ddec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d9ddec",
  null
  
)

export default component.exports